"use strict";
(function(window) {
    window.MapComponent = function() {
        this.$mapElement     = null;
        this.googleMapObject = null;
        this.markers         = [];
        this.cluster         = null;
        this.infoWindow      = null;
    };

    $.extend(window.MapComponent.prototype, {
        initMap: function() {
            this.$mapElement = $('.js-search-map');

            this.clearMarkers();

            if (this.$mapElement.length) {
                var mapOptions = {
                    center: {lat: this.$mapElement.data('center-latitude'), lng: this.$mapElement.data('center-longitude')},
                    zoom: 9,
                    styles: this.getMapStyles(),
                    disableDefaultUI: true,
                    zoomControl: true
                };

                this.googleMapObject = new google.maps.Map(this.$mapElement[0], mapOptions);
                this.infoWindow      = new google.maps.InfoWindow();

                this.loadMarkers();
            }
        },

        loadMarkers: function () {
            var self = this;
            var markers = this.$mapElement.data('markers');

            $.each(markers, function (index, value) {
                var image = {
                    url: self.$mapElement.data('marker-icon'),
                    // This marker is 20 pixels wide by 32 pixels high.
                    scaledSize: new google.maps.Size(40, 40),
                    // The origin for this image is (0, 0).
                    origin: new google.maps.Point(0, 0),
                    // The anchor for this image is the base of the flagpole at (0, 32).
                    anchor: new google.maps.Point(20, 40)
                };

                var marker = new google.maps.Marker({
                    map: self.googleMapObject,
                    draggable: false,
                    position: {lat: value.lat, lng: value.lng},
                    icon: image
                });

                marker.addListener('click', function() {
                    var infoWindowContent = '<h2>' + value.nom + '</h2>';
                    if (value.adresse !== null || value.cp !== null || value.ville !== null) {
                        infoWindowContent += '<address class="mb15">';
                        if (value.adresse !== null) {
                            infoWindowContent += value.adresse + '<br>';
                        }
                        if (value.cp !== null) {
                            infoWindowContent += value.cp + '<br>';
                        }
                        if (value.ville !== null) {
                            infoWindowContent += value.ville + '<br>';
                        }
                        infoWindowContent += '</address>';
                    }
                    infoWindowContent += '<a class="button small" href="' + value.path + '">' + value.trad + '</a>';

                    self.infoWindow.setContent(infoWindowContent);
                    self.infoWindow.open(self.googleMapObject, marker);
                });

                marker.setMap(self.googleMapObject);

                self.markers.push(marker);
            });

            this.cluster = new MarkerClusterer(
                this.googleMapObject,
                this.markers,
                {
                    gridSize: 50,
                    maxZoom: 15,
                    imagePath: self.$mapElement.data('cluster-icons')
                }
            );
        },

        clearMarkers: function () {
            for (var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.markers = [];
        },

        refreshMap: function () {
            google.maps.event.trigger(this.googleMapObject, 'resize');
        },

        getMapStyles: function() {
            return [
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#747474"
                        },
                        {
                            "lightness": "23"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#f38eb0"
                        }
                    ]
                },
                {
                    "featureType": "poi.government",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ced7db"
                        }
                    ]
                },
                {
                    "featureType": "poi.medical",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffa5a8"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#c7e5c8"
                        }
                    ]
                },
                {
                    "featureType": "poi.place_of_worship",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#d6cbc7"
                        }
                    ]
                },
                {
                    "featureType": "poi.school",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#c4c9e8"
                        }
                    ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#b1eaf1"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffd4a5"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffe9d2"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "weight": "3.00"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "weight": "0.30"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#747474"
                        },
                        {
                            "lightness": "36"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#e9e5dc"
                        },
                        {
                            "lightness": "30"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#d2e7f7"
                        }
                    ]
                }
            ];
        }
    });
})(window);

window.mapComponent = new MapComponent();
window.onloadGoogleMaps = function() {
    window.mapComponent.initMap();
};